import Button from './Button'
import { ReactComponent as PlusIcon } from '../assets/images/icons/ic-plus.svg'

export default function CreateButton({ children, style, ...props }) {
    return <Button {...props} requiresEdit appearance="default" accentColor="var(--primary)" style={{ ...style, minHeight: 40, padding: '.65rem 1rem', borderRadius: 8, fontSize: '.75rem', whiteSpace: 'nowrap', gap: '.5rem' }}>
        <PlusIcon aria-hidden="true" style={{ width: 18, height: 18, flexShrink: 0 }} />
        {children}
    </Button>
}
